import { homePageActionTypes as actionTypes } from "./types";

export const fetchHomePageDataStart = () => ({
  type: actionTypes.FETCH_HOME_PAGE_DATA_START,
});
